<template>
  <div class="about-container">
    <div class="container">
      <div class="tabs">
        <div id="about" class="active" @click="selectTab('about')">
          The Firm
        </div>
        <div id="projects" @click="selectTab('projects')">Director</div>
      </div>

      <div class="tab-content">
        <div id="about-content" class="about active">
          <h2 class="heading">The Firm</h2>

          <p>
            Each one of us has always dreamt of a home of our own. And when it
            comes to our dream home, we always look for someone trustworthy who
            can deliver us with their full potential and loyalty. This is where
            we step forward.
          </p>

          <p>
            Life Style Developers is one of the leading player in real estate
            and development industry. Our focus has always been on delivering
            dream homes to our customer as a reliable partner. While dong this
            we also believe in keeping our standard of quality high, which keeps
            our customers satisfied. And this does not end here, we also provide
            the best customer service and the uncompromising values as we firmly
            believe in our principles. The firm's main goal is to provide the
            best real estate services in all the areas we serve.
          </p>
        </div>
        <div id="projects-content" class="projects">
          <h2 class="heading">Director</h2>
          <br />
          <div class="director-content">
            <div class="director-image">
              <img
                
                src="../assets/sir.jpg"
                alt="director image"
              />
            </div>
            <div class="director-info">
              Ravindra V. Patil<br />
              B.E. Civil<br />
              21 st March 1965  
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    selectTab: function(tabName) {
    //   console.log(tabName);
      var tabs = document.querySelectorAll(".tabs > div");
      var tabContents = document.querySelectorAll(".tab-content > div");

      tabs.forEach((tab) => {
        if (tab.id !== tabName) {
          tab.classList.remove("active");
        } else {
          tab.classList.add("active");
        }
        // console.log(tab.id);
      });

      tabContents.forEach((content) => {
        if (content.id !== tabName + "-content") {
          content.classList.remove("active");
        } else {
          content.classList.add("active");
        }
      });
      // console.log(tabs);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");

* {
  /*background-color: black;*/
  /*border: 1px solid red;*/
}

.director-content {
  display: flex;
}
.director-image {
    height: 280px;
}
.director-image > img{
    height: 100%;
    width: 250px;
    object-fit: cover;
    border-radius: 50%;
}
/* Tab styling */

.tabs {
  display: flex;
}
.tabs > div {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid black;
  transform: border 0.4s ease;
  text-transform: uppercase;
  font-weight: bold;
}

.tabs > div.active {
  border-bottom: 4px solid #005570;
  background: rgb(196, 196, 196);
}

.tab-content > .about,
.tab-content > .projects {
  /* background: red; */
  padding: 20px 0;
  display: none;
}

.tab-content > .about.active,
.tab-content > .projects.active {
  display: block;
}

/* tab styling end */

.director-img-container {
  display: inline-block;
  height: 500px;
}

.director-info {
  /* display: inline-block;
  position: absolute;
  margin-left: 2vw; */
  text-align: center;
}

.director-img {
  border-radius: 100%;

  width: 100%;
  height: 240px;
}

.container {
}

body .container input {
  display: none;
}

body .container input:checked + label {
  background: #e8e8e8;
}

body .container input#tab1:checked ~ .line {
  left: 0%;
}

body .container input#tab1:checked ~ .content-container #c1 {
  opacity: 1;
}

body .container input#tab2:checked ~ .line {
  left: 25%;
}

body .container input#tab2:checked ~ .content-container #c2 {
  opacity: 1;
}

body .container input#tab3:checked ~ .line {
  left: 50%;
}

body .container input#tab3:checked ~ .content-container #c3 {
  opacity: 1;
}

body .container input#tab4:checked ~ .line {
  left: 75%;
}

body .container input#tab4:checked ~ .content-container #c4 {
  opacity: 1;
}

body .container label {
  display: inline-block;
  font-size: 16px;
  height: 36px;
  line-height: 36px;
  width: 25%;
  text-align: center;
  background: #ffffff;
  color: #555555;
  position: relative;
  -webkit-transition: 0.25s background ease;
  transition: 0.25s background ease;
  cursor: pointer;
}

body .container label::after {
  content: "";
  height: 2px;
  width: 100%;
  position: absolute;
  display: block;
  background: #ccc;
  bottom: 0;
  opacity: 0;
  left: 0;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
}

body .container label:hover::after {
  opacity: 0;
}

body .container .line {
  position: absolute;
  height: 2px;
  background: #1e88e5;
  width: 25%;
  top: 34px;
  left: 0;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
}

body .container .content-container {
  background: #ffffff;
  position: relative;
  /*font-size: 16px;*/
}

body .container .content-container .content {
  position: absolute;
  padding: 10px;
  width: 100%;
  top: 0;
  opacity: 0;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
  color: #333;
}

body .container .content-container .content h3 {
  font-weight: 200;
  margin: 10px 0;
}

body .container .content-container .content p {
  margin: 10px 0;
}

body .container .content-container .content p,
body .container .content-container .content i {
  font-size: 16px;
}

/*//////////////*/

.about-container {
  padding-top: 20vh;
  padding-left: 10vw;
  padding-bottom: 200px;
  padding-right: 10vw;
  /* margin-bottom: 10vh; */
  /* height: 100vh; */
  /*background-image: url("../assets/background.png");*/
  /*background-position-y: 10vh;*/
  /*background-position-x: 64vw;*/
  /*background-size: 40%;*/

  background-image: url("../assets/about_us_background.png");
  /*background-position-x: 0;*/
  /*background-position-y: 0;*/
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 100vw auto;
}

.heading {
  font-family: Poppins;
  /*font-style: normal;*/
  /*font-weight: 500;*/
  /*font-size: 2rem;*/
  /*line-height: 85%;*/
  font-size: 2rem;
  /*width: 80vw;*/
  /*text-align: center;*/
}

/*.content {*/
/*    padding-top: 3vh;*/
/*    width: 50vw;*/
/*    font-family: Poppins sans-serif;*/
/*    font-style: normal;*/
/*    font-weight: normal;*/
/*    font-size: 1rem;*/
/*    line-height: 237%;*/
/*    margin-bottom: 20vh;*/
/*    !*text-align: center;*!*/
/*}*/

@media screen and (max-width: 500px) {
  .content {
    width: 80vw;
  }

.director-content {
  flex-direction: column;
}
.director-image > img{
    width: 100%;
}
.director-image {
    height: 370px;
}
  .about-container {
    /* height: 110vh; */

    padding-top: 15vh;
    padding-left: 10vw;
    padding-bottom: 80px;
    background-image: url("../assets/about_us_background.png");
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 100vw auto;
  }

  .director-img-container {
    display: block;
  }

  .director-info {
    /* position: absolute; */
    /* margin-left: 18vw; */
    margin-bottom: 10vh;
    margin-top: 50px;
    /* text-align: center; */
  }

  .director-img {
    border-radius: 100%;
    width: 75vw;
    height: 300px;
  }
}
@media screen and (max-width: 400px) {
  .about-container {
    /* height: 130vh; */
  }
}
@media screen and (max-width: 350px) {
  .about-container {
    /* height: 180vh; */
  }
  body .container label {
    display: inline-block;
    font-size: 16px;
    height: 36px;
    line-height: 36px;
    width: 50%;
    text-align: center;
    background: #ffffff;
    color: #555555;
    position: relative;
    -webkit-transition: 0.25s background ease;
    transition: 0.25s background ease;
    cursor: pointer;
  }
}
</style>
